export const EM_DASH = '—'

export const EN_DASH = '–'
